// Shared change-type metadata for the Compare screen and its exports.

export const CHANGE_LABEL = {
  'new-failure': 'New failure',
  fixed: 'Fixed',
  'still-failing': 'Still failing',
  'status-changed': 'Status changed',
  'perf-regression': 'Perf regression',
  'perf-improvement': 'Perf improvement',
};
